module.exports = __webpack_public_path__ + "static/media/1009867.a7104feb.jpg";